import { useDispatch, useSelector } from "react-redux";
import { isLoadingUser, getUser, getUsersError } from "selectors/usersSelectors";
import { useEffect, useState } from "react";
import { getUserRequest } from "actions/userActions";
import { UserId } from 'shared/models';
import { State } from "reducers";

export function useUser(userId: UserId | null, refresh: boolean = false) {
    const dispatch = useDispatch();

    const [ reload, setReload ] = useState(refresh);
    const isLoading = useSelector((state: State) => userId ? isLoadingUser(state, { userId }) : false);
    const user = useSelector((state: State) => userId ? getUser(state, { userId }) : null);
    const error = useSelector(getUsersError);

    useEffect(() => {
        if (!userId) return;
        if (userId === 'new' || userId === 'assign') return;
        if (reload || (!isLoading && !user && !error)) {
            setReload(false);
            dispatch(getUserRequest(userId));
        }
    }, [ reload, dispatch, userId, isLoading, user, error, setReload ]);

    return {
        user,
        isLoadingUser: isLoading,
        loadingUserError: error,
    };
}
